import {
  BabbelFonts as InternalBabbelFonts,
  Heading as InternalHeading,
  BodyText as InternalText,
  Title as InternalTitle,
} from '@lessonnine/design-system.lib'
import { CURRENT_DS_VERSION } from 'src/dataLayer/localData/designSystem'
import { DS_VERSIONS } from 'src/dataLayer/localData/designSystem/versions'

const Typography = {
  [DS_VERSIONS.default]: {
    BabbelFonts: InternalBabbelFonts,
    Heading: InternalHeading,
    Text: InternalText,
    Title: InternalTitle,
  },
}

export default Typography[CURRENT_DS_VERSION]
